<cwc-header design-version="v2" slot="header" show-cemex-logo="true" show-Menu-Button="true">
    <div class="name_app">

        <h1> {{ 'name_app' | translate }}</h1>

    </div>
    <div class="btn_actions_top">

        <div class="d-flex gap-2 flex-wrap justify-content-end">

            <button [appCanAction]="ACTIONS.CUSTOMERS.CREATE" class="btn btn-secundary small" (click)="navigateTo('/admin/customer/add')" variant="primary"> {{
                'register_user' | translate }}</button>

            <button [appCanAction]="ACTIONS.INVOICES.CREATE" class="btn btn-primary small" (click)="navigateTo('/admin/invoices/add')" variant="primary"> {{
                'register_invoice' | translate }}</button>
        </div>

        <!-- <cwc-button design-version="v2" (click)="navigateTo('/admin/customer/add')" leading-icon="user-regular">
            {{ 'register_user' | translate }}</cwc-button>

        <cwc-button design-version="v2" (click)="navigateTo('/admin/invoices/add')"
            leading-icon="module-invoices-payments" variant="primary"> {{ 'register_invoice' | translate }}</cwc-button> -->

    </div>

    <cwc-topnav-menu designVersion="v2" [menu]="menu" ariaLabelNavAttr="Main Menu">
    </cwc-topnav-menu>


</cwc-header>